import React, { Fragment } from "react";
import { Container } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import DashboardMetrics from "./DashboardMetrics";
import UnknownArtistDistributions from "./UnknownArtistDistributions";
import "./dashboard-home.scss";

const Dashboard = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle="Dashboard" />
      <Container fluid className="rd-dashboard">
        <DashboardMetrics />
        <div className="rd-dashboard-distributions">
          <UnknownArtistDistributions />
        </div>
      </Container>
    </Fragment>
  );
};

export default Dashboard;
